import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import Gallery from '@/components/Gallery'
import Album from '@/components/Album'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home
		},
		{
			path: '/contact',
			component: Contact
		},
		{
			path: '/gallery',
			component: Gallery
		},
		{
			path: '/album/:id',
			component: Album,
			props: true
		}
	],
	scrollBehavior(to, from, savedPosition){
		return {x: 0, y: 0}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js